import React, { useEffect, useState } from "react"
import { DebugWebchat } from "../WebchatCard/WebchatCard"
import styles from "./WebchatCard.module.scss"
import { useGetWebChatAdditionalDataQuery } from "../../../../../api/controllers/channels/controller"
import AdvancedSkeleton from "../../../../Skeleton/AdvancedSkeleton"
import ErrorMessage from "../../../../ErrorMessage/ErrorMessage"

export interface WebchatFrameProps {
    debugWebchat: DebugWebchat
    projectId: string
}

const WebchatFrame: React.FC<WebchatFrameProps> = props => {
    const { debugWebchat, projectId } = props
    const [height, setHeight] = useState<number>()
    const { data, error, isLoading } = useGetWebChatAdditionalDataQuery({
        projectId,
        channelId: debugWebchat.channelId
    })
    const origin = data?.testPageUrl ? new URL(data.testPageUrl).origin : ""
    const url = `${origin}/webchat/scenario/${debugWebchat.channelId}/${debugWebchat.articleId}/${debugWebchat.showInput}`

    const processIframeMessage = (event: MessageEvent) => {
        const data = event.data
        if (data.notificationType === "WEBCHAT-INFO") {
            setHeight(data.height)
        }
    }

    useEffect(() => {
        window.addEventListener("message", processIframeMessage)
        return () => {
            window.removeEventListener("message", processIframeMessage)
        }
    }, [])

    if (error) {
        return <ErrorMessage text={error instanceof Error ? error.message : "Error occurred"} />
    }

    if (isLoading || origin.length === 0) {
        return <AdvancedSkeleton className={styles.skeleton} count={1}></AdvancedSkeleton>
    }

    return <iframe className={styles.webchatFrame} height={height} src={url} title="Webchat iframe"></iframe>
}

export default WebchatFrame
